import { render } from "./SamplingPoints.view.vue?vue&type=template&id=04acb3e0&scoped=true&ts=true"
import script from "./SamplingPoints.view.vue?vue&type=script&lang=ts"
export * from "./SamplingPoints.view.vue?vue&type=script&lang=ts"

import "./SamplingPoints.view.vue?vue&type=style&index=0&id=04acb3e0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04acb3e0"]])

export default __exports__